import { render } from "./QuizDetailsSection.vue?vue&type=template&id=4a917105&ts=true"
import script from "./QuizDetailsSection.vue?vue&type=script&lang=ts"
export * from "./QuizDetailsSection.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__